import React from 'react'
import {
  useStripe,
  useElements,
  PaymentElement,
  Elements,
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import Loading from 'components/loading'

// export const StripePromiseKey =
// 'pk_test_51KBaSUJ2qUwjWnLeL3yLhfgXb4UOFJvTRYtCN8DYaZ5yj4G1tFOEbbRgUCQ1SD0G0sFkPgS9QhcVeCvkoEnk1Ng000azmZlRkV'
export const StripePromiseKey =
  'pk_live_51KBaSUJ2qUwjWnLevYB31yemSurdPIqbyea4Iw9q01E5d0Qoo1BUB2DvfzQJY1sYKSjNJeycMhM1sg7Pdw26OP5R00RIFSvtk5'

export const CheckoutForm = (props) => {
  const { data, onComplete } = props
  const stripe = useStripe()
  const elements = useElements()

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault()

    // Loading.show()

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      // Loading.hide()
      return
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: `${location.href}${
          /\?[\w\d=&%]+/gi.test(location.href) ? '&' : '?'
        }paymentId=${data.metadata.order_id}`,
      },
    })

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      Loading.hide()
      onComplete({
        result: 'fail',
        message: result.error.message,
      })
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement
        onLoaderStart={() => {
          // Loading.show()
        }}
        onReady={() => {
          // Loading.hide()
        }}
        onLoadError={() => {
          // Loading.hide()
        }}
      />
      {
        <button
          disabled={!stripe}
          style={{
            display: 'block',
            width: '100%',
            padding: '15px 10px',
            margin: '15px 0 0',
            background: '#553eff',
            border: 'none',
            color: '#fff',
            fontFamily: 'Sora,sans-serif',
            fontWeight: 500,
            borderRadius: '4px',
          }}
          onClick={() => {
            Loading.show()
          }}
        >
          PAY
        </button>
      }
    </form>
  )
}

const Index = ({
  stripeCheckout,
  onFail,
}: {
  stripeCheckout: any
  onFail: (data: any) => void
}): JSX.Element => {
  const stripePromise = loadStripe(StripePromiseKey)
  return (
    <>
      <Elements
        stripe={stripePromise}
        options={{
          clientSecret: stripeCheckout.client_secret,
          locale: 'en',
          appearance: {
            theme: 'stripe',
          },
        }}
      >
        <CheckoutForm
          data={stripeCheckout}
          onComplete={(data) => {
            if (data && data.result === 'fail') {
              onFail(data)
            }
          }}
        />
      </Elements>
    </>
  )
}

export default Index
